import { sortPartRequest } from "../../../actions/course-author/common";
import { PreferredLocale } from "../../../utils/locales";
import { CourseUnitView, IAssessment, ICourseEditOperations, IFullCourse } from "../types";

export enum PassRequirementValue {
  Assessment = "assessment",
  AssessmentAndReview = "assessment-and-review",
  AssessmentOrReview = "assessment-or-review",
  Review = "review",
}

export interface IAssessmentState {
  formValues: { [input in InputNames]: string | number | null | boolean };
  test: IAssessment;
}

export interface IAssessmentOwnProps {
  unitPath: CourseUnitView[];
  currentLocale: PreferredLocale;
  editOperations: ICourseEditOperations;
}

export interface IAssessmentStateProps {
  accountId: string;
  course: IFullCourse;
  courseId: string;
}

export interface IAssessmentDispatchProps {
  sortPart: typeof sortPartRequest;
}

export type IAssessmentProps = IAssessmentOwnProps & IAssessmentDispatchProps & IAssessmentStateProps;

export enum InputNames {
  Accumulate = "accumulate",
  MistakesAllowed = "mistakes-allowed",
  NumRequiredCorrect = "num-required-correct",
  OrderPreference = "order-preference",
  Randomize = "randomize",
  RequiredAssessment = "require-assessment",
  ShowCorrect = "show-correct",
}
